export default (function (array, callback) {
  return array.reduce(function (partialObject, element) {
    return callback(partialObject, element);
  }, {});
});


//////////////////
// WEBPACK FOOTER
// ../~/redux-actions/es/arrayToObject.js
// module id = 1617
// module chunks = 0